/**
 * @description
 * Button state type
 * @enum {string}
 * @property {string} PRESSED - Pressed state
 * @property {string} LOADING - Loading state
 * @property {string} DEFAULT - Default state
 * @property {string} DISABLED - Disabled state
 * @property {string} HOVER - Hover state
 * @example
 * <Button state={ButtonStateType.PRESSED} />
 */
export var ButtonStateType;
(function (ButtonStateType) {
    ButtonStateType["PRESSED"] = "PRESSED";
    ButtonStateType["LOADING"] = "LOADING";
    ButtonStateType["DEFAULT"] = "DEFAULT";
    ButtonStateType["DISABLED"] = "DISABLED";
    ButtonStateType["HOVER"] = "HOVER";
})(ButtonStateType || (ButtonStateType = {}));
//# sourceMappingURL=state.js.map